// extracted by mini-css-extract-plugin
export default {"badge_container":"badge_container__0025b1f6","hidden":"hidden__0025b1f6"};